(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6635],{

/***/ 5396:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles-guides",
      function () {
        return __webpack_require__(36950);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var storyblok__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47659);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94842);
/* harmony import */ var _components_global_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6695);
/* harmony import */ var _components_global_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50794);
/* harmony import */ var _components_seo_BaseSeo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57758);
/* harmony import */ var _components_StoryblokPages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34153);
/* harmony import */ var _lib_storyblok_storyblokNavLinks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83176);








var sbPageParams = function(preview) {
    return {
        preview: preview,
        starts_with: "articles-guides/",
        getTags: true,
        startPage: false
    };
};
var Page = function(param) {
    var page = param.page, story = param.story, preview = param.preview, resolve_relations = param.resolve_relations, childPageData = param.childPageData;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var sbStory = preview ? (0,storyblok__WEBPACK_IMPORTED_MODULE_1__/* .useStoryblok */ .P)(story, preview, resolve_relations) : story;
    var globalLinks = (0,_lib_storyblok_storyblokNavLinks__WEBPACK_IMPORTED_MODULE_7__/* .getStoryBlokNavLinks */ .G)(story);
    var _content = sbStory.content, _headerTheme = _content.headerTheme, headerTheme = _headerTheme === void 0 ? "" : _headerTheme, _footerTheme = _content.footerTheme, footerTheme = _footerTheme === void 0 ? "" : _footerTheme, _SEO = _content.SEO, SEO = _SEO === void 0 ? {} : _SEO, _name = sbStory.name, name = _name === void 0 ? "" : _name, full_slug = sbStory.full_slug;
    var haveChildPages = childPageData.pages && childPageData.pages.length > 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo_BaseSeo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: SEO === null || SEO === void 0 ? void 0 : SEO.title,
                description: SEO === null || SEO === void 0 ? void 0 : SEO.description,
                ogDescription: SEO === null || SEO === void 0 ? void 0 : SEO.og_description,
                ogTitle: SEO === null || SEO === void 0 ? void 0 : SEO.og_title,
                image: SEO === null || SEO === void 0 ? void 0 : SEO.og_image,
                path: full_slug
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                blok: sbStory.content,
                navigation: globalLinks,
                headerTheme: headerTheme,
                pageName: name,
                hasBorder: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                id: "main",
                className: "page-padding-top",
                children: haveChildPages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StoryblokPages__WEBPACK_IMPORTED_MODULE_6__/* .LargeCardGrid */ .Pu, {
                        sbPageParams: sbPageParams(preview),
                        childPageData: childPageData,
                        parentSlug: "articles_guides",
                        cardVariant: "articles-card"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                theme: footerTheme,
                navigation: globalLinks.footerLinks
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);
Page.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .Ar, {
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7099,9370,8578,7715,3873,7972,5568,3161,4153,9774,2888,179], function() { return __webpack_exec__(5396); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);